import { render, staticRenderFns } from "./CreateGlobalMessage.vue?vue&type=template&id=477f7439&scoped=true"
import script from "./CreateGlobalMessage.vue?vue&type=script&lang=js"
export * from "./CreateGlobalMessage.vue?vue&type=script&lang=js"
import style0 from "./CreateGlobalMessage.vue?vue&type=style&index=0&id=477f7439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f7439",
  null
  
)

export default component.exports